'use strict';
angular
    .module('editingCenterCompiledModule', [
        'editingCenterCompiledRouterModule',
        'editingCenterCompiledRecycleModule',
        'editCenterNewsModule',
        'editCenterAtlas',
        'editingCenterSubjectModule',
        'editingCenterAddWebsiteModule',
        'editingCenterCompiledMoveModule',
        'editingCenterCompiledTimingSignModule',
        'editingCenterAppActivityModule',
        'editingCenterAppLiveModule',
        'editingCenterAppTopicModule',
        'editingCenterAppVideoModule',
        'editingCenterAppAudioModule',
        'editingCenterCompiledRecycleModule',
        'editingCenterAppOperationalActivityModule',
        'editingCenterAppAdvertisementModule',
    ])
    .controller('editCompileController', [
        '$scope',
        '$stateParams',
        '$q',
        '$window',
        '$filter',
        'trsHttpService',
        '$state',
        'modalDialog',
        'sensitiveWordCheckService',
        'trsspliceString',
        'initSingleSelecet',
        'localStorageService',
        'editingCenterService',
        'globleParamsSet',
        'editingCenterAppService',
        'storageListenerService',
        'editcenterRightsService',
        'editIsLock',
        'newMediaService',
        'appConst',
        'editingMediatype',
        function (
            $scope,
            $stateParams,
            $q,
            $window,
            $filter,
            trsHttpService,
            $state,
            modalDialog,
            sensitiveWordCheckService,
            trsspliceString,
            initSingleSelecet,
            localStorageService,
            editingCenterService,
            globleParamsSet,
            editingCenterAppService,
            storageListenerService,
            editcenterRightsService,
            editIsLock,
            newMediaService,
            appConst,
            editingMediatype
        ) {
            initStatus();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.getPageSize(),
                };
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'queryToBeCompiledDoc',
                    PageSize: $scope.page.PAGESIZE,
                    CurrPage: $scope.page.CURRPAGE,
                    ChannelId: $stateParams.channelid,
                    SiteId: $stateParams.siteid,
                };
                $scope.childStatus = {
                    // 图片数组的string
                    checkString: 'DOC_PICTURELIST',
                    // 图片数组中表示url地址的string
                    picString: 'SRCPICURL',
                    originPicUrl: 'SRCPICURL'
                };
                $scope.status = {
                    copyCurrPage: 1,
                    channelId: $stateParams.channelid,
                    siteId: $stateParams.siteid,
                    onlyMine: false,
                    isESSearch: false,
                    batchOperateBtn: {
                        hoverStatus: '',
                        clickStatus: '',
                    },
                    hasphoto: false, // 是否是图集稿
                    hasphotoflag: true, // 判断是否人为点击图集切换模式
                    detailMethodname: {
                        1: 'getNewsDoc',
                        2: 'getPicsDoc',
                        3: 'getSpecialDoc',
                        4: 'getLinkDoc',
                        5: 'getActivityDoc',
                        6: 'getTopicDoc',
                        7: 'getVideoDoc',
                        8: 'getLiveDoc',
                        12: 'getAudioDoc',
                        13: 'getVideosDoc',
                        14: 'getOperateDoc',
                    },
                    signedSuccess: false,
                    showManuscriptType: {
                        '1': false,
                        '2': false,
                        '3': false,
                        '4': false,
                        '5': false,
                        '6': false,
                        '7': false,
                        '8': false,
                        '12': false,
                        '13': false,
                        '14': false,
                    },
                    // 增加一个标识，表示是否是全部栏目
                    isAllColumns: $state.params.channelid === '0',

                    /* selectedArrayLength: 0,*/
                };
                $scope.data = {
                    selectedArray: [],
                    items: [],
                    editPath: editingCenterAppService.initEditPath(),
                    printResult: [],
                    filterArray: [],
                    // 一个栏目发送一次请求，预防多次发请求
                    requestedColumnsBtnRight: {},
                    trench: appConst.params.listenStroageKey,
                };
                // 监听未保存的专题分组，并删除
                $window.addEventListener('storage', function (e) {
                    var draftInfo = localStorageService.get('unsavedGroup');
                    if (draftInfo && draftInfo.specialGroupIds) {
                        localStorageService.remove('unsavedGroup');
                        deleteUnsavedGroup(draftInfo).then(function (data) { });
                    }
                });
            }

            /**
             * [deleteUnsavedGroup description] 删除未保存的专题分组
             * @param  {[type]} draftInfo [description] 分组信息和稿件信息
             * @return {[type]}           [description]
             */
            function deleteUnsavedGroup(draftInfo) {
                var defer = $q.defer();
                var params;
                if (draftInfo.metadataid == '0') {
                    params = {
                        serviceid: 'mlf_specialgroup',
                        methodname: 'deleteUnrelatedSpecialGroups',
                        ObjectIds: draftInfo.specialGroupIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve();
                    });
                } else {
                    params = {
                        serviceid: 'mlf_specialgroup',
                        methodname: 'deleteSpecialGroupFromData',
                        MetaDataId: draftInfo.metadataid,
                        SpecialGroupIds: draftInfo.specialGroupIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve();
                    });
                }
                return defer.promise;
            }

            /**
             * [initData description]初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                if (!$stateParams.channelid) {
                    $scope.status.hidePage = true; // 如果栏目参数不足，隐藏改页面
                    return;
                }
                if ($scope.status.isAllColumns) {
                    delete $scope.params.ChannelId;
                    // 增加一个参数 标识全部栏目的参数
                    $scope.params.IsLoadAllChnl = true;
                    initDropDown();
                    requestData();
                    $scope.status.btnRights = editingCenterAppService.initDaiBianBtnRight();
                } else {
                    queryChannelDetail().then(function () {
                        initDropDown();
                        requestData();
                    });
                    editcenterRightsService.initAppListBtn('app.daibian', $stateParams.channelid).then(function (rights) {
                        $scope.status.btnRights = rights;
                        getObjLength($scope.status.btnRights);
                    });
                }

                listenStorage();
            }

            // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
            $scope.requestData = function () {
                initData();
            };

            /**
             * [getObjLength description]计算对象长度
             *
             * @param   {[type]}  obj  [obj description]
             *
             * @return  {[type]}       [return description]
             */
            function getObjLength(obj) {
                var size = 0,
                    key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        size++;
                    }
                }
                $scope.status.btnLength = size;
            }

            /**
             * [initDropDown description]初始化下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                // editingCenterService.dealStorage($scope);
                // $scope.data.singleJsons = initSingleSelecet.docStatus();
                // $scope.data.docStatus = angular.copy($scope.data.singleJsons[0]);
                // 根据可新建稿件类型初始化‘全部稿件’下拉框
                var docTypeJsons = initSingleSelecet.appDocType();
                if (!$scope.status.isAllColumns) {
                    $scope.data.docTypeJsons = [];
                    $scope.data.docTypeJsons.push(docTypeJsons[0]);
                    for (var i = 0; i < docTypeJsons.length; i++) {
                        for (var j in $scope.data.manuscriptTypes) {
                            if (docTypeJsons[i].value === $scope.data.manuscriptTypes[j]) {
                                $scope.data.docTypeJsons.push(docTypeJsons[i]);
                                break;
                            }
                        }
                    }
                    if ($scope.data.manuscriptTypes.indexOf($scope.params.DocType) === -1) {
                        delete $scope.params.DocType;
                        $scope.data.selectedDocType = angular.copy($scope.data.docTypeJsons[0]);
                    }
                } else {
                    $scope.data.docTypeJsons = docTypeJsons;
                }
                $scope.data.timeTypeJsons = initSingleSelecet.timeType();
                $scope.data.selectedTimeType = angular.copy($scope.data.timeTypeJsons[0]);
                $scope.data.sortTypeJsons = initSingleSelecet.sortType();
                $scope.data.sortType = angular.copy($scope.data.sortTypeJsons[1]);
                $scope.data.classifyJsons = initSingleSelecet.iWoEntire();
                $scope.data.selectedClassify = angular.copy($scope.data.classifyJsons[0]);
            }

            /**
             * [queryChannelDetail description] 根据栏目ID获取可新建稿件类型
             * @return {[type]} [description]
             */
            function queryChannelDetail() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'queryChannelDetail',
                    ChannelId: $stateParams.channelid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.manuscriptTypes = data[0].APPOPERTYPE.split(',');
                    angular.forEach($scope.data.manuscriptTypes, function (data, index) {
                        $scope.status.showManuscriptType[data] = true;
                    });
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenApp(function () {
                    $scope.status.isESSearch = false;
                    requestData();
                    storageListenerService.removeListener('app');
                }, $scope);
            }

            /**
             * [requestData description]数据请求函数
             * @return {[type]} [description]
             */
            function requestData() {
                var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    var ListItems = data.DATA;
                    $scope.data.items = ListItems;
                    if ($scope.data.selectedDocType) {
                        if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                            $scope.status.hasphoto = true;
                        } else {
                            $scope.status.hasphoto = false;
                        }
                    }
                    $scope.data.filterReviseItem = ListItems.filter((item) => item.APPSTATUSNAME !== '待修订');
                    !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                    $scope.data.selectedArray = [];
                    requestListImg(ListItems).then(function (data) {
                        angular.forEach(ListItems, function (value, key) {
                            value.ALLIMG = data[value.METADATAID];
                        });
                    });
                    newMediaService.getReviseInfo(ListItems);
                });
            }

            /**
             * [ getFinalBtnRightdescription]点击第一次发请求
             * @param   {[type]}  item  [items description]
             * @return {[json]} [description] 参数对象
             */
            function getAllColumnsBtnRight(item) {
                if (!$scope.status.isAllColumns) {return;}
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.btnRights = editingCenterAppService.initDaiBianBtnRight();
                    return;
                }

                if (!$scope.data.requestedColumnsBtnRight[item.CHANNELID]) {
                    $scope.loadingPromise = editcenterRightsService.initAppListBtn('app.daibian', item.CHANNELID).then(function (rights) {
                        $scope.data.requestedColumnsBtnRight[item.CHANNELID] = rights;
                        $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.data.requestedColumnsBtnRight);
                    });
                } else {
                    $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.data.requestedColumnsBtnRight);
                }

            }


            /**
             * [ intersectAll]对最终的权限按钮进行交集操作
             *
             * @return {[json]} [description] 参数对象
             */
            function intersectAll() {

                // 默认把他置空
                // $scope.data.selected2DArray = [];
                // 通过已选择的稿件
                // var selectedArr = trsspliceString.spliceString($scope.data.selectedArray, 'CHANNELID', ',');
                // // 对数组去个重
                // selectedArr = selectedArr.split(',');
                // selectedArr = distinct(selectedArr);
                // angular.forEach(selectedArr, function(data, index, array){
                //     // data等价于array[index]
                //     $scope.data.selected2DArray.push($scope.data.requestedColumnsBtnRight[data]);
                // });
                // if ($scope.data.selected2DArray.length === 1) {
                //     $scope.status.btnRights = $scope.data.selected2DArray[0];
                //     getObjLength($scope.status.btnRights);
                // } else if ($scope.data.selected2DArray.length > 1) {
                //     var intersection = angular.copy($scope.data.selected2DArray[0]);
                //     for (var i = 1; i < $scope.data.selected2DArray.length; i++){
                //         for (var key in intersection) {
                //             if (!$scope.data.selected2DArray[i][key]) {
                //                 delete intersection[key];
                //             }
                //         }
                //     }
                //     $scope.status.btnRights = intersection;
                //     getObjLength($scope.status.btnRights);
                // }
            }

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description] 参数对象
             */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForAppToBeCompiledDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [
                            {
                                searchField: $scope.data.selectedClassify.value,
                                keywords: $scope.keywords ? $scope.keywords : '',
                            },
                            {
                                searchField: 'docType',
                                keywords: $scope.data.selectedDocType ? $scope.data.selectedDocType.value : '',
                            },
                            {
                                searchField: 'timeType',
                                keywords:
                                    angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                        ? $scope.data.fromdate + ',' + $scope.data.untildate
                                        : $scope.data.selectedTimeType.value,
                            },
                            {
                                searchField: 'isOnlyMine',
                                keywords: $scope.status.onlyMine,
                            },
                            {
                                searchField: 'channelid',
                                keywords: $stateParams.channelid,
                            },
                            {
                                searchField: '_sort',
                                keywords: $scope.data.sortType.value,
                            },
                        ],
                    },
                };
                // 所有栏目下  不传channelid 传siteid
                if ($scope.status.isAllColumns) {
                    esParams.searchParams.searchFields[4] = {
                        searchField: 'siteid',
                        keywords: $state.params.siteid,
                    };
                    // 点击检索时 默认应该展示全部按钮
                    $scope.status.btnRights = editingCenterAppService.initDaiBianBtnRight();
                }
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }

            /**
             * [requestListImg description]查询列表图示
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            function requestListImg(items) {
                var defer = $q.defer();
                if (!items || items.length < 1) {
                    defer.resolve([]);
                } else {
                    var params = {
                        serviceid: 'mlf_myrelease',
                        methodname: 'queryAllImgLogo',
                        metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            }

            /**
             * [pageChanged description]跳转到下一页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description]跳转到指定页
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function () {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [atlasMode description] 图集模式
             * @return {[type]} [description]
             */
            $scope.atlasMode = function () {
                $scope.status.hasphoto = !$scope.status.hasphoto;
                $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
            };

            /**
             * [selectPageNum description]选择分页条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };

            /**
             * [selectAll description]稿件全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function () {
                $scope.data.selectedArray =
                    $scope.data.selectedArray.length == $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
            };

            /**
             * [selectDoc description]稿件单选
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                getAllColumnsBtnRight(item);

            };


            /**
             * [queryDropDown description]根据下拉条件查询列表
             *
             * @param   {[type]}  type   [type description]下拉条件
             * @param   {[type]}  value  [value description]下拉值
             *
             * @return  {[type]}         [return description]
             */
            $scope.queryDropDown = function (type, value) {
                $scope.params[type] = value;
                $scope.params.CurrPage = $scope.page.CURRPAGE = $scope.status.copyCurrPage = 1;
                if (type === 'timeType') {
                    $scope.params.OperTimeStart = $scope.data.fromdate;
                    $scope.params.OperTimeEnd = $scope.data.untildate;
                    $scope.params[type] = null;
                }
                if (type === 'DocType' && value === '2') {
                    $scope.status.hasphotoflag = true;
                }
                requestData();
            };

            /**
             * [showVersionTime description]流程版本时间与操作日志
             * @param   {[type]}  item  [item description]稿件对象
             * @return  {[type]}        [return description]
             */
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [goToDetail description]图集模式跳转细览页
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.goToDetail = function (item) {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID,CHNLDOCID', 'appPreview');
                var params = {
                    appchannelid: $scope.status.channelId,
                    takedraft: false,
                    appchnldocid: item.CHNLDOCID,
                    appsiteid: $scope.status.siteId,
                    appmetadataid: item.METADATAID,
                    appplatform: 0,
                    appdoctype: item.DOCTYPEID,
                    isawaitrevise: item.APPSTATUSNAME === '待修订' ? 'isAwaitRevise' : ''
                };
                var url = $state.href('appPreview', params);
                window.open(url);
            };

            /**
             * [isOnlyMine description]只看我的
             * @return {Boolean} [description] null
             */
            $scope.isOnlyMine = function () {
                $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.onlyMine = !$scope.status.onlyMine;
                $scope.params.isOnlyMine = $scope.status.onlyMine;
                requestData();
            };

            /**
             * [fullTextSearch description]全文检索
             *
             * @param   {[type]}  ev  [ev description]按下回车也能提交
             *
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.selectedClassify.value == 'DocID') {
                        $scope.status.isESSearch = false;
                        $scope.params.DocId = $scope.keywords;
                    } else {
                        $scope.status.isESSearch = true;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                    // $scope.status.isESSearch = false;
                }
            };

            /**
             * [trial description]稿件送审
             * @param  {[obj]} item [description]稿件信息
             * @return {[type]}      [description]
             */
            $scope.trial = function (item) {
                $scope.status.isESSearch = false;
                trial(item);
            };

            /**
             * [trial description]稿件送审函数
             * @param  {[obj]} item [description]稿件信息
             * @return {[type]}      [description]
             */
            function trial() {
                newMediaService.trial($scope, appConst.params.trialParams);
            }

            /**
             * [directSigned description]直接签发
             * @return {[type]} [description]
             */
            $scope.directSigned = function () {
                var allPushHeadDraft = hasPushHeadDraft();
                if (allPushHeadDraft) {
                    modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                    return;
                }
                $scope.status.isESSearch = false;
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.filterArray, '', '1').then(
                    function () {
                        $scope.status.signedSuccess = true;
                        signed();
                    },
                    function () {
                        signed();
                    }
                );
            };

            /**
             * [signed description]直接签发函数
             * @return {[type]}      [description]
             */
            function signed() {
                $scope.loadingPromise = newMediaService.sign($scope, appConst.params.daibianSign, singCallBack);
            }

            /**
             * [reponseFilter description]过滤返回的reports
             * @param  {[obj]} elm [description]各个返回的report
             * @return {[null]}     [description]
             */
            $scope.reportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS === 'false';
                }
            };

            /**
             * [successReportsFilter description]过滤返回的签发成功项
             * @param  {[obj]} elm [description]返回的report
             * @return {[type]}     [description]
             */
            $scope.successReportsFilter = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS === 'true';
                }
            };

            /**
             * [timingSigned description]定时签发函数
             * @return {[type]}      [description]
             */
            $scope.timingSigned = function () {
                var allPushHeadDraft = hasPushHeadDraft();
                if (allPushHeadDraft) {
                    modalDialog.alertType('推头条稿件不可进行签发！', '', 'error', false);
                    return;
                }
                $scope.status.isESSearch = false;
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.data.filterArray, '').then(
                    function () {
                        //
                    },
                    function () {
                        timeSign();
                    }
                );
            };

            /**
             * [timeSign description]定时签发函数
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            function timeSign() {
                $scope.loadingPromise = newMediaService.timeSign($scope, appConst.params.daibianTimeSign, singCallBack);
            }

            /**
             * [singCallBack description] 签发回调
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function singCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            /**
             * [draftlist description]发稿单
             * @return {[type]} [description] null
             */
            $scope.draftlist = function () {
                $scope.status.isESSearch = false;
                newMediaService.draftlist($scope, appConst.params.draftListDB, appConst.params.draftListQuery);
            };

            /**
             * [batchDelete description]废稿
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.batchDelete = function (item) {
                $scope.status.isESSearch = false;
                abandonDraft(item);
            };

            /**
             * [abandonDraft description]废稿函数
             * @param  {[obj]} item [description]稿件信息
             * @return {[type]}      [description]
             */
            function abandonDraft(item) {
                newMediaService.delete($scope, appConst.params.delete);
            }

            /**
             * [collect description]稿件收藏
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            $scope.collect = function (item) {
                $scope.status.isESSearch = false;
                if (editcenterRightsService.judgeCanBeCollected($scope.data.selectedArray)) {
                    modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                    return;
                } else {
                    collectDraft();
                }
            };

            /**
             * [collectDraft description]收藏稿件函数
             * @param  {[obj]} item [description]稿件具体信息
             * @return {[type]}      [description]
             */
            function collectDraft(item) {
                $scope.loadingPromise = newMediaService.collect($scope, appConst.params.collect);
            }

            /**
             * [move description]移动稿件
             * @return {[type]} [description]
             */
            $scope.move = function () {
                $scope.status.isESSearch = false;
                editingCenterAppService.moveDraft('移动稿件', $stateParams.siteid, $stateParams.channelid, 7, function (result) {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'moveDaiBianMetaDatas',
                        ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                        ToChannelId: result.channelid,
                        SrcChannelId: $stateParams.channelid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function (data) {
                            modalDialog.alertType('稿件移动成功', '', 'success', false);
                            requestData();
                        },
                        function () {
                            requestData();
                        }
                    );
                });
            };

            /**
             * [outSending description]外发功能
             * @return {[type]} [description]
             */
            $scope.outSending = function () {
                if (!selectDraftTip()) {
                    return;
                }
                $scope.status.isESSearch = false;
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
                if (temp.length < 1) {
                    editingCenterService.outSending('', function (result) {
                        outSendingDraft(result.selectItems);
                    });
                } else {
                    modalDialog.alertType('只能外发新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [outSendingDraft description]外发函数
             * @param  {[array]} items [description]外发服务的返回值
             * @return {[type]}       [description]
             */
            function outSendingDraft(items) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'appDaiBianSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                            requestData();
                        });
                    },
                    function () {
                        $scope.data.selectedArray = [];
                    }
                );
            }

            /**
             * [print description]
             * @return {[type]} [description]
             */
            $scope.print = function () {
                $scope.status.isESSearch = false;
                editingCenterAppService.printDoc($scope);
            };

            /**
             * [exportDraft description]导出功能
             * @return {[type]} [description]
             */
            $scope.exportDraft = function () {
                if (!selectDraftTip()) {
                    return;
                }
                $scope.status.isESSearch = false;
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
                if (temp.length < 1) {
                    var params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        function (data) {
                            $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            $scope.data.selectedArray = [];
                        },
                        function (data) {
                            if (data.REPORTS[0].ISSUCCESS == 'true') {
                                $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                                $scope.data.selectedArray = [];
                            }
                        }
                    );
                } else {
                    modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [examDraftType description]检验稿件类型
             * @param  {[obj]} elm [description]稿件的具体信息
             * @return {[type]}     [description]
             */
            $scope.examDraftType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID * 1 !== 1 && elm.DOCTYPEID * 1 !== 2;
                }
            };

            /**
             * [isLockEdit description]编辑前请求解锁
             * @param   {[type]}  item  [item description]稿件对象
             * @return  {[type]}        [return description]
             */
            $scope.routerToEdit = function (item) {
                $scope.status.isESSearch = false;
                let editUrl = packageRouterParams(item);
                if (angular.isObject(item)) {
                    editIsLock.isLock(item, editingMediatype.website).then(function (data) {
                        if (data.ISLOCK === 'false') {
                            $window.open(editUrl);
                        } else {
                            editIsLock.checkUnlockPermissions(item, data).then(function () {
                                $window.open(editUrl);
                            });
                        }
                    });
                } else {
                    $window.open(editUrl);
                }
            };

            /**
             * [packageRouterParams description] 组装路由参数
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function packageRouterParams(item) {
                let editPath = $scope.data.editPath[item.DOCTYPEID || item];
                let editParams = {
                    appchannelid: $state.params.channelid,
                    appchnldocid: item.CHNLDOCID,
                    appmetadataid: item.METADATAID,
                    appsiteid: $state.params.siteid,
                    appplatform: 0,
                };
                return $state.href(editPath, editParams);
            }

            /**
             * [appPreview description] app稿件预览
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.appPreview = function () {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID,CHNLDOCID', 'appPreview');
            };

            /**
             * [hasPushHeadDraft description] 判断所选稿件中是否存在推头条稿件
             * @return {Boolean} [description]
             */
            function hasPushHeadDraft() {
                var allPushHeadDraft = false;
                $scope.data.filterArray = [];
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].METADATAID == '884193') {
                        $scope.data.selectedArray[i].PUSHHEADLINETYPE = '2';
                    }
                    if ($scope.data.selectedArray[i].PUSHHEADLINETYPE != '2') {
                        // 非头条稿件可进行签发操作
                        $scope.data.filterArray.push($scope.data.selectedArray[i]);
                    }
                }
                if ($scope.data.filterArray.length === 0) {
                    allPushHeadDraft = true;
                }
                return allPushHeadDraft;
            }

            /**
             * [manuscriptShare description]稿件分享
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.manuscriptShare = function (item) {
                $scope.loadingPromise = editingCenterService.manuscriptShare(item, function (data) {
                    requestData();
                });
            };

            /**
             * [appMobilePreview description]客户端手机端模板预览
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.appMobilePreview = function (item) {
                editingCenterAppService.appPrevewPublish(item.CHNLDOCID).then(
                    function () { },
                    function () {
                        editIsLock.lockDraft(item.CHNLDOCID);
                    }
                );
            };

            /**
             * [generateQrcode description] 展示二维码
             * @param   {[type]}  item  [item description] 选中的app稿件
             * @return  {[type]}        [return description]
             */
            $scope.generateQrcode = function (item) {
                $scope.loadingPromise = editingCenterAppService.appPrevewPublish(item.CHNLDOCID, '', true).then(function (data) {
                    if (data.EXCEPTIONDETAIL) {
                        modalDialog.alertType('获取二维码地址失败', data.EXCEPTIONDETAIL.substr(0, 500) + '...', 'error', 'confirm');
                    } else {
                        var qrcodeUrl = window.location.protocol + '//' + window.location.host + data.URLS[0]; // 二维码地址
                        editingCenterService.generateQrcode(qrcodeUrl);
                    }
                });
            };

            /**
             * [revise description]修订
             * @return {[type]} [description]
             */
            $scope.revise = function () {
                var transferData = {
                    serviceid: 'mlf_modifydoc',
                    methodname: 'appointDocToUserOfAppDaiBian',
                    SiteId: $stateParams.siteid,
                    DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                    UserId: '',
                };
                newMediaService.revise($scope, transferData);
            };
         
            /** 多元分发
             * [distribution description]
             * @return {[type]} [description]
             */
            $scope.distribution = function () {
                $scope.status.isESSearch = false;
                if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')) {
                    modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                    return;
                }
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
                if (temp.length < 1) {
                    editingCenterService.distribution($scope.data.selectedArray, '1', $scope.data.selectedArray[0].DOCTYPEID, 'appDaiBianDistribute', function () {
                        $scope.data.selectedArray = [];
                        requestData();
                    });
                } else {
                    modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、图集、视频', 'warning', 'confirm');
                }
            };

            /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
             * [examDistributionType description]
             * @param  {[type]} elm [description]
             * @return {[type]}     [description]
             */
            $scope.examDistributionType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2 && elm.DOCTYPEID != 7;
                }
            };

            /**
             * [selectDraftTip description] 选择稿件提示
             * @return {[boolean]} [description]
             */
            function selectDraftTip() {
                var flag = true;
                if ($scope.data.selectedArray.length === 0) {
                    flag = false;
                    modalDialog.alertType('请先选择稿件', '', 'warning', 'confirm');
                }
                return flag;
            }
        },
    ]);
